import DateSelector from "components/components/DateSelector/DateSelector";
import DateFilterModel from "models/filterModels/dateFilterModel";
import React from "react";
import {
  MAX_DAYS_IN_ONE_YEAR,
  restrictDateFilterToMaxDaysRange,
} from "utils/dateHelpers";

interface Props {
  dateFilter: DateFilterModel;
  setDateFilter: (dateFilter: DateFilterModel) => void;
}

const SubmissionDateTimeFilter: React.FC<Props> = ({
  dateFilter,
  setDateFilter,
}: Props) => {
  const handleChangeToDateSelection = (
    newDateFilter: DateFilterModel
  ): void => {
    setDateFilter(
      restrictDateFilterToMaxDaysRange(newDateFilter, MAX_DAYS_IN_ONE_YEAR)
    );
  };

  return (
    <>
      <h2>Submission time frame</h2>
      <DateSelector
        dateFilter={dateFilter}
        handleChangeToDateSelection={handleChangeToDateSelection}
        dateTabs={[]}
        activeTab={null}
        maxRange={MAX_DAYS_IN_ONE_YEAR}
      />
    </>
  );
};

export default SubmissionDateTimeFilter;
